<template>
  <polling-channel
    :input="event"
    :active="pollingActive"
    :updateFunction="updateEvent"
    @valueUpdated="onEventUpdate"
  >
    <template v-slot="props">
      <slot :event="props.currentValue"/>
    </template>
  </polling-channel>
</template>

<script>
import PollingChannel from '@/components/atoms/PollingChannel';
import { isEditingTimedOut } from '@/libs/isEditingTimedOut';

export default {
  name: 'StationEventPolling',
  components: {
    PollingChannel,
  },
  props: {
    event: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      pollingActive: this.needsPolling(this.event),
    };
  },
  methods: {
    needsPolling(event) {
      if (!event) {
        return false;
      }
      if (event.processing) {
        return true;
      }
      return event.updating && !isEditingTimedOut(event, Date.now());
    },
    onEventUpdate(updatedEvent) {
      this.$emit('eventUpdated', updatedEvent);
      if (!this.needsPolling(updatedEvent)) {
        this.pollingActive = false;
      }
    },
    async updateEvent() {
      try {
        const { data } = await this.$http.get(`/api/v2/events/${this.event.id}`, { isBackgroundRequest: true });
        return data;
      } catch (_event) {
        // 画面の自動更新ポーリングのため握りつぶし、現在のイベントを返す（次回ポーリングで回復）
        return this.event;
      }
    },
  },
  watch: {
    event(value) {
      this.pollingActive = false;
      this.$nextTick().then(() => {
        this.pollingActive = this.needsPolling(value);
      });
    },
  },
};
</script>
